<template>
<div class="nj-input-date">
    <div class="nj-label">{{ label }}</div>
    <b-datepicker v-model="date" size="is-small" icon="calendar-today" locale="en-GB" @input="input($event)" :month-names="meses" style="padding: 0 !important;"></b-datepicker>
</div>
</template>
<script>
import { DateTime } from "../../util"

export default {
    name: "InputDate",
    props: {
        value: null,
        label: {
            type: String,
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    watch: {
        value(newValue) {
            this.date = DateTime.stringToDate(newValue)
        }
    },
    components: {

    },
    data() {
        return {
            date: null,
            meses: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"]
        }
    },
    methods: {
        input(value) {
            let _date = DateTime.dateToString(value)
            this.$emit("input", _date)
        },
    },
    mounted() {

    }
}
</script>

<style scoped>
.nj-input-date {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    gap: 0;
    margin: 0 0 6px 0;
}
</style>